import { useNavigate } from "react-router-dom";
import React from "react";
import { User } from "lucide-react";

const GroupCard = ({ group }) => {
  const {
    groupName,
    groupLearningLanguage,
    groupAdminName,
    groupAdminImageUrl,
    memberIds = [],
    imageUrl,
    id,
    isPremium,
  } = group;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/groupDetailsUser/${id}`);
  };

  return (
    <div onClick={handleClick}>
      {" "}
      <div
        className={`mx-auto h-[340px] w-full max-w-sm rounded-[32px] border p-6 hover:cursor-pointer ${
          isPremium
            ? "border-[#14B82C] bg-[#f0fdf1]"
            : "border-[#ffc310] bg-[#ffffea]"
        }`}
      >
        <div className="flex flex-col items-center">
          {/* Group Image Container */}
          <div className="relative mb-4 h-40 w-40">
            {/* Bambuu+ Tag */}
            {isPremium && (
              <div className="absolute -top-3 left-1/2 z-10 w-28 -translate-x-1/2">
                <img
                  alt="bammbuu"
                  src="/svgs/bammbuu-plus-grp-tag.svg"
                  className="w-28"
                />
              </div>
            )}
            {/* Group Image */}
            <div className="h-full w-full overflow-hidden rounded-full">
              <img
                src={imageUrl}
                alt={groupName}
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          {/* Group Name */}
          <h2 className="mx-auto mb-4 max-w-[200px] truncate whitespace-nowrap text-center text-2xl font-semibold text-gray-900">
            {groupName}
          </h2>

          {/* Language */}
          <div className="mb-6 flex items-center gap-2">
            <div className="h-6 w-6 overflow-hidden rounded-full">
              <img
                src={
                  groupLearningLanguage === "English"
                    ? "/svgs/xs-us.svg"
                    : groupLearningLanguage === "Spanish"
                      ? "/svgs/xs-spain.svg"
                      : "/svgs/eng-spanish-xs.svg"
                }
                alt={
                  groupLearningLanguage === "English" ? "US Flag" : "Spain Flag"
                }
                className="h-5 w-5 sm:w-auto"
              />
            </div>
            <span className="text-md max-w-[180px] truncate whitespace-nowrap text-center font-medium">
              {groupLearningLanguage}
            </span>
          </div>

          {/* Admin and Member Count */}
          <div className="flex w-full items-center justify-between">
            <div className="flex min-w-0 max-w-[70%] items-center gap-2">
              <div className="flex-shrink-0">
                {groupAdminImageUrl ? (
                  <img
                    src={groupAdminImageUrl}
                    alt={groupAdminName}
                    className="h-5 w-5 rounded-full object-cover"
                  />
                ) : (
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200">
                    <User className="h-5 w-5 text-gray-600" />
                  </div>
                )}
              </div>
              <span className="truncate text-gray-700">
                {groupAdminName} <span className="text-gray-500">(Admin)</span>
              </span>
            </div>
            <div className="flex flex-shrink-0 items-center gap-1">
              <img
                src="/svgs/users.svg"
                alt={groupAdminName}
                className="h-5 w-5 rounded-full object-cover"
              />{" "}
              <span className="text-gray-700">{memberIds.length}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupCard;
